import {
  startOfDay,
  endOfDay,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfQuarter,
  endOfQuarter,
  subDays,
  subWeeks,
  subMonths,
  subQuarters,
} from "date-fns";

// Global dashboard date-range presets. Ranges are computed in the browser's
// LOCAL timezone; week starts on MONDAY (weekStartsOn: 1). We send the range
// boundaries as ISO instants (UTC) to the backend for filtering.
export const RANGE_OPTIONS = [
  { value: "all", label: "All Time" },
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "this_week", label: "This Week" },
  { value: "last_week", label: "Last Week" },
  { value: "this_month", label: "This Month" },
  { value: "last_month", label: "Last Month" },
  { value: "this_quarter", label: "This Quarter" },
  { value: "last_quarter", label: "Last Quarter" },
];

const MONDAY = { weekStartsOn: 1 };

export function computeRange(value, now = new Date()) {
  switch (value) {
    case "today":
      return { start: startOfDay(now), end: endOfDay(now) };
    case "yesterday": {
      const y = subDays(now, 1);
      return { start: startOfDay(y), end: endOfDay(y) };
    }
    case "this_week":
      return { start: startOfWeek(now, MONDAY), end: endOfWeek(now, MONDAY) };
    case "last_week": {
      const lw = subWeeks(now, 1);
      return { start: startOfWeek(lw, MONDAY), end: endOfWeek(lw, MONDAY) };
    }
    case "this_month":
      return { start: startOfMonth(now), end: endOfMonth(now) };
    case "last_month": {
      const lm = subMonths(now, 1);
      return { start: startOfMonth(lm), end: endOfMonth(lm) };
    }
    case "this_quarter":
      return { start: startOfQuarter(now), end: endOfQuarter(now) };
    case "last_quarter": {
      const lq = subQuarters(now, 1);
      return { start: startOfQuarter(lq), end: endOfQuarter(lq) };
    }
    case "all":
    default:
      return { start: null, end: null };
  }
}

// Returns {start, end} as ISO strings (or nulls) for API query params.
export function rangeParams(value, now = new Date()) {
  const { start, end } = computeRange(value, now);
  return {
    start: start ? start.toISOString() : null,
    end: end ? end.toISOString() : null,
  };
}
